import { useState, useEffect } from 'react';
import { Box, Stack, Typography, useTheme, TablePagination, Button, IconButton } from '@mui/material';
import React from 'react';
import Datatable from '../../../components/DataTable';
import TablePaginationActions from '../../../components/TablePaginationActions';
import PageHeader from '../../../components/PageHeader';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useSelector } from 'react-redux';
import { CancelToken } from 'apisauce';
import appapi from '../../../api/apiClient';
import { dialogButtonCancel } from '../../../utils/commonStyle';
import AddEditContacts from './Components/AddEditContacts';
import ContactsDetails from './Components/ContactDetails';
import ConfirmArchiveDialog from '../../../components/ConfirmArchiveDialog';
import ArchiveUserList from '../UserManagement/Components/ArchiveUserList';
import ArchiveContactList from './Components/ArchiveContactList';
import { checkPermission } from '../../../redux/features/authSlice';
import { useTranslation } from 'react-i18next';
import AccessDenied from '../AccesDenied/AccessDenied';
import { initShipCharterers, initShipManagers, initShipOperators, initShipOwners } from '../../../redux/features/layoutSlice';

const companyType = [
  {
    id: 'ship owner',
    name: 'Ship Owner',
  },
  {
    id: 'ship manager',
    name: 'Ship Manager',
  },
  {
    id: 'operator',
    name: 'Operator',
  },
  {
    id: 'charterer',
    name: 'Charterer',
  },
];

export default function ContactManagement() {
  const theme = useTheme();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [contactList, setContactsList] = useState([]);
  const { t } = useTranslation();
  const [openAddEditContacts, setOpenAddEditContacts] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [contactDetails, setContactDetails] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [type, setType] = useState('');

  const [selectedHistory, setSelectedHistory] = useState(null);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [openArchiveList, setOpenArchiveList] = useState(false);
  const [list, setList] = useState([])

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    companyTypeFilter: [],
    field: '_id',
    sortOrder: 'desc',
  });

  const { userId, companyDetails, user } = useSelector((state) => state.auth);

  const contactPermission = useSelector((state) => checkPermission(state, 'Contact Management', 'Manage Contacts'));

  let source = CancelToken.source();
  const text = theme.palette.primary.text;

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
      default: true,
      columnEditable: false,
      activeColumn: true,
    },
    {
      id: 1,
      header: 'Company name',
      accessor: 'companyName',
      width: '25%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 2,
      header: 'Company type',
      accessor: 'companyType',
      width: '10%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'checkbox',
        typeFilter: true,
        filterList:
          companyType?.map((item) => {
            return {
              label: item?.name,
              value: item?.id,
            };
          }) || [],
      },
    },
    {
      id: 3,
      header: 'Full name',
      accessor: 'name',
      width: '15%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 4,
      header: 'Email',
      accessor: 'email',
      width: '20%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 5,
      header: 'Phone',
      accessor: 'phoneNumber',
      width: '10%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      Cell: (value) => (
        <div className="flex ">
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {value?.phoneCode || ''}
            {'-'}
            {value?.phoneNumber || '-'}
          </Typography>
        </div>
      ),
    },
    {
      id: 6,
      header: 'Country',
      accessor: 'countryName',
      width: '10%',
      default: false,
      columnEditable: true,
      activeColumn: false,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 7,
      header: 'State',
      accessor: 'stateName',
      width: '10%',
      default: false,
      columnEditable: true,
      activeColumn: false,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, filter: search }));
  };

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    setSelectedHistory(checkedStatus ? item : null);
  };

  const handleOnArchive = (item) => {
    setOpenArchiveDialog(true);
  };

  useEffect(() => {
    setList(
      contactList.map((res, index) => {
        return {
          ...res,
          // Sno: index + 1,
          isSelected: false,
        };
      }),
    );
  }, [contactList]);

  useEffect(() => {
    if (list.length > 0) {
      if (selectedHistory) {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: res._id === selectedHistory._id,
          };
        });
        setList(items);
      } else {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: false,
          };
        });
        setList(items);
      }
    }
  }, [selectedHistory]);


  const handleGetContacts = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/contact-management/all/companyContacts`,
      {
        pageNumber: payload.page,
        filter: payload.filter || null,
        pageSize: payload.limit,
        companyTypeFilter: payload.companyTypeFilter,
        sortOrderField: payload.field === 'companyName' ? 'sortCompanyName' : payload.field === 'name' ? 'sortName' : payload.field,
        sortOrder: payload.sortOrder,
        companyId: user?.companyId,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setContactsList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.response?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setContactsList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setContactsList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    if (contactPermission.viewAccess) {
      handleGetContacts()
    }
      return () => {
        if (source) {
          source.cancel();
        }
      };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.field, payload.sortOrder, payload.companyTypeFilter, contactPermission.viewAccess]);

  const selectRow = (sitem, sindex) => {
    const contacts = contactList.map((item, index) => {
      item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
      item.selected = item._id === sitem._id;
      return item;
    });
    setSelectedData(sitem);
    setContactsList(contacts);
    setIsDrawerOpen(true);
  };

  const handleExcelDownload = async (format) => {
    const response = await appapi.get(
      `/contact-management/all/downloadExcelCompanyContacts`,
      {
        filter: payload.filter || null,
        companyTypeFilter: payload.companyTypeFilter,
        sortOrderField: payload.field === 'companyName' ? 'sortCompanyName' : payload.field === 'namen' ? 'sortName' : payload.field,
        sortOrder: payload.sortOrder,
        companyId: user?.companyId,
        format,
      },
      { observe: 'response', responseType: 'blob' },
    );
    if (response.ok) {
      try {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const ext = format === 'csv' ? 'csv' : 'xlsx';
        link.download = `CONTACT${new Date().getTime()}.${ext}`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading:', error);
      }
    } else {
    }
  };

  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  return (
    contactPermission?.viewAccess ? <Stack
      flex={1}
      direction={'row'}
      className="m-[8px] rounded-[8px] bg-white"
    >
      <Stack flex={1}>
        <PageHeader
          handleFilterButton={payload.totalLength > 0 ? true : false}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
          showExport={contactPermission.addAccess ? (payload.totalLength > 0 ? true : false) : false}
          onExport={(type) => {
            handleExcelDownload(type);
          }}
          showArchive={contactPermission.archiveAccess}
          disableArchive={selectedHistory ? false : true}
          onArchive={(item) => handleOnArchive(item)}
          columnPreference={payload.totalLength > 0 ? true : false}
          columns={customerManagementColumn}
          applyColumnPreference={(c) => setCustomerManagementColumn(c)}
          onRefresh={() => {
            if (payload.page === 1) {
              handleGetContacts();
            } else {
              setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1 }));
            }
          }}
        >
          <Stack
            direction="row"
            flex={1}
          >
            <Stack flexGrow={1} />
            {contactPermission.addAccess && <Button
              sx={{ color: theme.palette.primary.main, textTransform: 'uppercase' }}
              className="fs-14 ff-Roboto fw-medium !mr-[20px]"
              onClick={() => {
                setOpenAddEditContacts(true);
                setType('add');
                setContactDetails(null);
              }}
              variant="text"
              startIcon={<PersonAddIcon />}
            >
              {t('Add contact')}
            </Button>}
          </Stack>
        </PageHeader>
        <Stack
          flexGrow={1}
          className="relative flex-auto overflow-auto h-0"
        >
          <Datatable
            tableHeadBgColor={'#e2eeff'}
            columns={customerManagementColumn.filter((res) => res.activeColumn)}
            data={list || []}
            isLoading={isLoading}
            showCheckBox={contactPermission.archiveAccess}
            onChangeCheckBox={handleOnChangeCheckBox}
            onClickRow={(item, index) => {
              selectRow(item, index);
            }}
            onChangeFilter={(filterValues) => {
              const sortValues = filterValues?.sort;
              let columnUpdate = customerManagementColumn;
              columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
              if (sortValues) {
                columnUpdate = columnUpdate.map((res) => {
                  return {
                    ...res,
                    sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                  };
                });
              }
              setCustomerManagementColumn(columnUpdate);
              if (sortValues) {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order, companyTypeFilter: filterValues?.filter.selectValue }));
              } else {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, companyTypeFilter: filterValues?.filter.selectValue }));
              }
            }}
          />
        </Stack>

        <Stack
          sx={{ width: '100%' }}
          className="relative inputFormStyle"
          direction={'row'}
        >
          {contactPermission.archiveAccess && <Button
            sx={[
              dialogButtonCancel,
              {
                color: theme.palette.primary.main,
                fontSize: '14px',
                '&:hover': {},
              },
            ]}
            style={{ width: '230px', height: '48px' }}
            onClick={() => {
              setOpenArchiveList(true);
            }}
          >
            {t('View archive')}
          </Button>}
          <Box className="flex  justify-end items-center h-[56px] w-[100%] p-[5px]">
            <TablePagination
              sx={{ borderBottom: 0 }}
              rowsPerPageOptions={[]}
              count={payload.totalLength ? payload.totalLength : 0}
              rowsPerPage={payload.limit ? payload.limit : 10}
              page={payload.paginationPage ? payload.paginationPage : 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box>
        </Stack>
      </Stack>
      <Stack>
        {isDrawerOpen && <ContactsDetails
          isDrawerOpen={isDrawerOpen}
          permission={contactPermission}
          toggleDrawer={() => {
            if (selectedData) {
              handleToggleDrawer();
            }
          }}
          openEditContacts={(data) => {
            setOpenAddEditContacts(true);
            setContactDetails(data);
            setType('edit');
          }}
          contact={selectedData}
          init={() => handleGetContacts()}
        />}
      </Stack>
      {openAddEditContacts && (
        <AddEditContacts
          contact={contactDetails}
          modelOpen={openAddEditContacts}
          onModelHandleClose={(event) => {
            if (event) {
              setPayload((prev) => ({ ...prev, page: 1 }));
              handleGetContacts();
            }
            setOpenAddEditContacts(false);
          }}
          type={type}
        />
      )}
      {openArchiveDialog && (
        <ConfirmArchiveDialog
          modelOpen={openArchiveDialog}
          onModelHandleClose={(event) => {
            if (event) {
              setOpenArchiveDialog(false);
              setOpenArchiveList(false);
              setPayload((prev) => ({ ...prev, page: 1 }));
              handleGetContacts();
              setSelectedHistory(null)
            }
            setOpenArchiveDialog(false);
          }}
          data={selectedHistory}
          type={'contact'}
          status={1}
        />
      )}
      {openArchiveList && (
        <ArchiveContactList
          modelOpen={openArchiveList}
          onModelHandleClose={(event) => {
            setOpenArchiveList(false);
            if(event) {
              setPayload((prev) => ({ ...prev, page: 1 }));
              handleGetContacts();
            }
            
          }}
        />
      )}
    </Stack> : <AccessDenied />
  );
}
